function Decimal(number){
	return Number(number.toString().replace(/[^0-9\.\,]/g, '').replace(',', '.'));
}

export default Decimal;